import { Controller } from "react-hook-form";

import type { BaseQuestionProps, QuestionOption } from "../types";

import { FieldsetRating } from "./FieldsetRating";
import { RatingOption } from "./RatingOption";

type RatingQuestionProps = {
  options: QuestionOption[];
} & BaseQuestionProps;

export function RatingQuestion({
  control,
  errors,
  label,
  name,
  options,
  questionNumber,
}: RatingQuestionProps) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <FieldsetRating
          data-field-name={name}
          errorMessage={errors[name]?.message as string}
          isInvalid={!!errors[name]}
          label={label}
          onChange={field.onChange}
          questionNumber={questionNumber}
          value={field.value as string}
        >
          {options.map((option) => (
            <RatingOption key={option.value} label={option.label} value={option.value} />
          ))}
        </FieldsetRating>
      )}
    />
  );
}
